import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationService } from '../../../organizations/organization.service';
import { Organization } from '../../sdk';
import { WhiteLabelService } from '../../services/whitelabel.service';

@Component({
  selector: 'app-organization-edit',
  templateUrl: './organization-edit.component.html',
  styleUrls: ['./organization-edit.component.css'],
})
export class OrganizationEditComponent implements OnInit {
  @Input() org: Organization;
  @Input() validateEslog: boolean;
  @Input() validateOnInit: boolean;
  organizationForm = this.fb.group({
    id: [''],
    name: ['', Validators.required],
    address: [''],
    address2: [''],
    zip: [''],
    city: [''],
    country: ['', Validators.required],
    taxNumber: [''],
    taxSubject: [''],
    companyNumber: [''],
    IBAN: [''],
    bank: [''],
    SWIFT: [''],
    website: [],
    email: [],
    phone: [],
    custom: [],
  });
  validateFurs: boolean;
  sent = false;

  constructor(
    public wls: WhiteLabelService,
    private activeModal: NgbActiveModal,
    private orgService: OrganizationService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    const furs_verifying = this.orgService.findDefault(
      this.org,
      'furs_verifying',
    );
    this.validateFurs = !!furs_verifying ? furs_verifying.value : false;

    this.organizationForm.patchValue(this.org);

    this.sent = this.validateOnInit;

    if (this.validateEslog) {
      this.organizationForm.controls.address.setValidators(Validators.required);
      this.organizationForm.controls.zip.setValidators(Validators.required);
      this.organizationForm.controls.city.setValidators(Validators.required);
      this.organizationForm.controls.taxNumber.setValidators(
        Validators.required,
      );
      this.organizationForm.controls.companyNumber.setValidators(
        Validators.required,
      );
      this.organizationForm.updateValueAndValidity();
    }
  }

  onSave() {
    this.sent = true;

    if (this.organizationForm.valid) {
      this.orgService
        .patch(
          this.organizationForm.get('id').value,
          this.organizationForm.value,
          true,
          false,
        )
        .subscribe((org: Organization) => {
          this.activeModal.close(org);
        });
    }
  }

  onClose() {
    this.activeModal.dismiss();
  }
}
